module.exports = __webpack_public_path__ + "static/media/index.97ddc224.less";